import React from "react";
import {PageHeader} from "./PageHeader"
import {DataBox} from "./DataBox"
import {DetailDrawer} from "./DetailDrawer"
const TechnicianItem = () => {
    return (
        <>
            <PageHeader/>
            <DataBox/>
            <DetailDrawer/>
        </>
    )
}
export default TechnicianItem